import './open_files_dialog.less';
import {Overlay} from 'neuroglancer/overlay';
import i18n from 'neuroglancer/i18n/i18n'
import {makeElement} from "neuroglancer/ui/layer_gene_table_tab";
import {_localIP_host, formatterURLHREF, viewer} from 'src/main';
import {cancellableFetchSpecialOk} from "neuroglancer/util/special_protocol_request";
import {responseJson} from "neuroglancer/util/http_request";
import {message} from "neuroglancer/widget/message";


export class OpenFilesDialog extends Overlay {
  iframe = document.createElement('iframe');
  buttonOpenFilesConform: HTMLElement | null;
  isFilesValid = false;
  isAddFiles = false;

  constructor(isAddFiles = false) {
    super();
    this.isAddFiles = isAddFiles;
    this.initDom();
  }

  initDom() {
    const iframeContainer = makeElement('div', ['iframe_container'], {});
    this.content.appendChild(iframeContainer);
    const token = localStorage.getItem('ksh_token');
    const sessionId = localStorage.getItem('skfx_session');
    const _param = formatterURLHREF(location.href);
    const projectId =_param.projectId ?? 'projectid';
    // const stomicsDomain = 'http://dev/ngdataserverv3/';
    const stomicsDomain = process.env.domainConfig![process.env.NODE_ENV!].stomicsDomain;
    // https://alitest-cloud.stomics.tech/stereomap/?flag=tool&projectId=P20230713114146306&token=xxx
    this.iframe.src = `${stomicsDomain}#/select-file?projectId=${projectId}&fromModule=visualizationV3&token=${token}&session=${sessionId}&zone=${_param.zone || ''}`
    iframeContainer.appendChild(this.iframe);

    const footer = makeElement('div', ['footer']);
    this.content.appendChild(footer);
    const openFilesCancelBtn = makeElement('button', ['open_file_cancel'], {}, `${i18n.cancel}`);
    this.buttonOpenFilesConform = makeElement('button', ['open_file_conform', 'async_submit_btn_loading', 'disabled'], {}, `<i class="submit_btn_el-icon-loading"><svg t="1687856555440" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1917" width="14" height="14"><path d="M511.882596 287.998081h-0.361244a31.998984 31.998984 0 0 1-31.659415-31.977309v-0.361244c0-0.104761 0.115598-11.722364 0.115598-63.658399V96.000564a31.998984 31.998984 0 1 1 64.001581 0V192.001129c0 52.586273-0.111986 63.88237-0.119211 64.337537a32.002596 32.002596 0 0 1-31.977309 31.659415zM511.998194 959.99842a31.998984 31.998984 0 0 1-31.998984-31.998984v-96.379871c0-51.610915-0.111986-63.174332-0.115598-63.286318s0-0.242033 0-0.361243a31.998984 31.998984 0 0 1 63.997968-0.314283c0 0.455167 0.11921 11.711527 0.11921 64.034093v96.307622a31.998984 31.998984 0 0 1-32.002596 31.998984zM330.899406 363.021212a31.897836 31.897836 0 0 1-22.866739-9.612699c-0.075861-0.075861-8.207461-8.370021-44.931515-45.094076L195.198137 240.429485a31.998984 31.998984 0 0 1 45.256635-45.253022L308.336112 263.057803c37.182834 37.182834 45.090463 45.253022 45.41197 45.578141A31.998984 31.998984 0 0 1 330.899406 363.021212zM806.137421 838.11473a31.901448 31.901448 0 0 1-22.628318-9.374279L715.624151 760.859111c-36.724054-36.724054-45.018214-44.859267-45.097687-44.93874a31.998984 31.998984 0 0 1 44.77618-45.729864c0.32512 0.317895 8.395308 8.229136 45.578142 45.411969l67.88134 67.88134a31.998984 31.998984 0 0 1-22.624705 54.630914zM224.000113 838.11473a31.901448 31.901448 0 0 0 22.628317-9.374279l67.88134-67.88134c36.724054-36.724054 45.021826-44.859267 45.097688-44.93874a31.998984 31.998984 0 0 0-44.776181-45.729864c-0.32512 0.317895-8.395308 8.229136-45.578142 45.411969l-67.88134 67.884953a31.998984 31.998984 0 0 0 22.628318 54.627301zM255.948523 544.058589h-0.361244c-0.104761 0-11.722364-0.115598-63.658399-0.115598H95.942765a31.998984 31.998984 0 1 1 0-64.00158h95.996952c52.586273 0 63.88237 0.111986 64.337538 0.11921a31.998984 31.998984 0 0 1 31.659414 31.97731v0.361244a32.002596 32.002596 0 0 1-31.988146 31.659414zM767.939492 544.058589a32.002596 32.002596 0 0 1-31.995372-31.666639v-0.361244a31.998984 31.998984 0 0 1 31.659415-31.970085c0.455167 0 11.754876-0.11921 64.34115-0.11921h96.000564a31.998984 31.998984 0 0 1 0 64.00158H831.944685c-51.936034 0-63.553638 0.111986-63.665624 0.115598h-0.335957zM692.999446 363.0176a31.998984 31.998984 0 0 1-22.863126-54.381656c0.317895-0.32512 8.229136-8.395308 45.41197-45.578141l67.88134-67.884953A31.998984 31.998984 0 1 1 828.693489 240.429485l-67.892177 67.88134c-31.020013 31.023625-41.644196 41.759794-44.241539 44.393262l-0.697201 0.722488a31.908673 31.908673 0 0 1-22.863126 9.591025z" fill="#ffffff" p-id="1918"></path></svg></i>${i18n.confirm}`);
    footer.appendChild(openFilesCancelBtn);
    footer.appendChild(this.buttonOpenFilesConform);

    this.content.appendChild(this.buttonClose);
    this.content.classList.add('open_files_container');
    this.registerEventListener(this.buttonClose, 'click', () => {
      this.dispose();
    });
    this.registerEventListener(openFilesCancelBtn, 'click', () => {
      this.dispose();
    });
    this.registerEventListener(this.buttonOpenFilesConform, 'click', () => {
      if (this.isFilesValid) {
        this.getDataIdAndJump(viewer.filesInfoFormatted);
      }
    });
  }
  setConfirmBtnEnable(flag:boolean){
    this.isFilesValid = flag;
    if (flag) {
      this.buttonOpenFilesConform?.classList.remove('disabled');
    } else {
      this.buttonOpenFilesConform?.classList.add('disabled')
    }
  }
  async getDataIdAndJump(fileInfo: any) {
    const bodyParam = JSON.stringify(fileInfo)

    const _param = formatterURLHREF(location.href);
    const dataId =_param.DataID;
    const projectId =_param.projectId ?? 'projectid';
    this.buttonOpenFilesConform?.classList.add('submit_btn_loading');
    let res = await cancellableFetchSpecialOk(undefined, `${_localIP_host}${dataId??'default'}/tool/${projectId}/work_path`, {
      method: this.isAddFiles ? "PATCH" : "post",
      headers: {
        'Content-Type': 'application/json; charset=UTF-8' 
      },
      body: bodyParam
    }, responseJson).finally(()=>{
      this.buttonOpenFilesConform?.classList.remove('submit_btn_loading');
    });
    if (res.code === 0) {
      const newDataId = res.data.key;
      const repeatFiles = res.data.repeat;
      // let newURL = _localIP_host + DataID=T202307210006&flag=v2&sn=C01935E1&projectId=P1600787473158537217
      let newURL = `${location.origin}${location.pathname}?DataID=${newDataId}&flag=tool&projectId=${projectId}&zone=${_param.zone || ''}`;
      if (repeatFiles && repeatFiles.length > 0) {
        sessionStorage.setItem(newDataId + 'repeatFiles', JSON.stringify(repeatFiles));
      }
      window.open(newURL, '_self');
    } else if (res.code === 10003) {//批量文件报错
      const resData = res.data
      let massageStrList: Array<string> =  [];
      for(const key in resData) {
        resData[key].forEach((item: string)=>{
          massageStrList.push(item);
        })
      }
      new message(massageStrList, 'info', true);
    } else {//单个文件报错
      new message(res.msg, 'info', true);
    }
  }

  dispose() {
    super.dispose();
  }
}
